// extracted by mini-css-extract-plugin
export default {"container":"headerAvatar_container__mTmNr","dropdownContainer":"headerAvatar_dropdownContainer__XSu1d","text":"headerAvatar_text__kJolQ"};